import { IChartOptions } from './IChartOptions';
export class ChartOptions implements IChartOptions {
    translateX: number;
    translateY: number;
    translateTop: number;
    translateBottom: number;

    constructor(translateX: number,
        translateY: number,
        translateTop: number,
        translateBottom: number) {
        this.translateX = translateX;
        this.translateY = translateY;
        this.translateTop = translateTop;
        this.translateBottom = translateBottom;
    }
}